<template>
  <div>
    <el-dialog
      title="详情"
      :visible.sync="showSingleDialog"
      v-dialogDrag
      width="40%"
      class="details-continer"
    >
      <el-scrollbar style="height: calc(100vh - 500px)">
        <el-form>
          <ioc-tab-group
            :option="tabOption"
            @change="handleChange"
          ></ioc-tab-group>
          <div v-if="selector.prop === 'tab1'">
            <el-row>
              <el-col :span="24" style="height: 100px">
                <el-form-item label="车辆照片：">
                  <img
                    :src="imgPath(detailData.fileCode)"
                    @click="showBigImg(imgPath(detailData.fileCode), $event)"
                    class="stranger_img"
                    onerror="this.src='/images/theme/newDark/default.png'"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="车牌号：">
                  {{ detailData.plateCode }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="姓名：">
                  {{ detailData.name }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="工号：">
                  {{ detailData.workNo }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="电话：">
                  {{ detailData.phone }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="身份证：">
                  {{ detailData.idCard }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="车辆类型：">
                  {{ detailData.vehicleType | vehicleTypeFilter }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="车辆颜色：">
                  {{ detailData.vehicleColor | colorFilter }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="车辆品牌：">
                  {{ detailData.vehicleBrand }}
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="通行区域：">
                  {{ detailData.areaInfoStr }}
                </el-form-item>
              </el-col>
              <el-col :span="12" style="height: 100px">
                <el-form-item label="驾驶证：">
                  <div
                    class="driver-img-container"
                    v-for="(item, index) in detailData.driverCardFileCodeList"
                    :key="index"
                  >
                    <img
                      :src="imgPath(item)"
                      @click="showBigImg(imgPath(item), $event)"
                      class="stranger_img"
                      onerror="this.src='/images/theme/newDark/default.png'"
                    />
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12" style="height: 100px">
                <el-form-item label="行驶证：">
                  <img
                    :src="imgPath(detailData.vehicleCardFileCode)"
                    @click="
                      showBigImg(
                        imgPath(detailData.vehicleCardFileCode),
                        $event
                      )
                    "
                    class="stranger_img"
                    onerror="this.src='/images/theme/newDark/default.png'"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12" class="pr5">
                <el-form-item label="审批意见：">
                  {{ detailData.remark }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="来访事由：">
                  {{ detailData.visitorReason }}
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <el-row v-if="selector.prop === 'tab2'">
            <div class="process-container">
              <el-timeline direction="vertical">
                <el-timeline-item
                  v-for="(flowItem, index) in workFlowDetail"
                  :key="index"
                  placement="top"
                >
                  <el-card>
                    <div class="process-step-content">
                      <div class="left-box">
                        <p class="lh30">{{ flowItem.type | flowTypeFilter }}</p>
                        <p class="lh30" v-if="flowItem.type === '3'">
                          {{ "(" + flowItem.areaDevGroupName + ")" }}
                        </p>
                        <p class="lh30">{{ flowItem.operatorName }}</p>
                      </div>
                      <div class="right-box">
                        <p class="lh30">{{ flowItem.operatTime }}</p>
                        <p class="lh30">
                          {{ flowItem.status | flowStatusFilter }}
                        </p>
                      </div>
                    </div>
                  </el-card>
                </el-timeline-item>
              </el-timeline>
            </div>
          </el-row>
        </el-form>
      </el-scrollbar>
    </el-dialog>
  </div>
</template>
<script>
/**
 * 对话框组件
 */
import { api } from "../api/index";
import { Dic, Bus, Dates } from "$utils";
import utils from "@src/common/utils";
export default {
  name: "EduDialog",
  props: {
    width: {
      type: String,
      default: "80%",
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
    detailData: {
      type: Object,
      default: {},
    },
    workFlowDetail: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      showSingleDialog: false,
      tabOption: {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: "审批记录详情",
            prop: "tab1",
          },
          {
            label: "审批流程详情",
            prop: "tab2",
          },
        ],
      },
      selector: {},
    };
  },
  filters: {
    sexFilter(val, SENU) {
      return Dic.findByValue("SENU018", val);
    },
    colorFilter(val) {
      return Dic.findByValue("SENU039", val);
    },
    vehicleTypeFilter(val) {
      return Dic.findByValue("SENU038", val);
    },
    formartterTime(time) {
      return time
        ? Dates.dayjs(Number(time)).format("YYYY-MM-DD HH:mm:ss")
        : "";
    },
    flowTypeFilter(val) {
      return Dic.findByValue("SENU080002", val);
    },
    flowStatusFilter(val) {
      return Dic.findByValue("SENU080010", val);
    },
  },
  mounted() {},
  created() {
    this.selector = this.tabOption.column[0];
  },
  methods: {
    open() {
      this.showSingleDialog = true;
    },
    // 选项卡被选中时触发
    handleChange(column) {
      this.selector = column;
    },
    showBigImg(src, e) {
      this.$parent.showViewer(src, e);
    },
    isFactoryFormatter(data) {
      switch (data * 1) {
        //
        case 0:
          return "厂内";
        case 1:
          return "厂外";
        default:
          return data;
      }
    },
    imgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    close() {
      this.showSingleDialog = false;
    },
    onClose() {
      this.$emit("close");
    },
    confirm() {
      this.$emit("confirm");
    },
  },
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.details-continer {
  .el-row {
    .el-col {
      height: 30px;
    }

    &:nth-child(2) {
      height: 80px;
    }
  }
  .stranger_img {
    width: 80px;
    height: 80px;
    margin-right: 15px;
  }
  .driver-img-container {
    display: inline-block;
  }
  .process-container {
    padding: 10px;

    .el-timeline-item__tail {
      position: absolute;
      left: 6px;
      height: 100%;
      border-left: 2px solid #e4e7ed;
    }

    .el-timeline-item__node--normal {
      left: -1px;
      width: 15px;
      height: 15px;
    }

    .el-card {
      width: 80%;
      @include set_theme_color(border-color, active-border-color);
      @include set_theme_color(background-color, top-menu-bg-color);
      @include set_theme_color(color, font-default-color);
      -webkit-transition: 0.3s;
      transition: 0.3s;
    }

    .process-step-content {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .right-box {
        .detail-text {
          display: inline-block;
          cursor: pointer;
          @include set_theme_color(color, font-active-color);
        }
      }
    }
  }
}
</style>
